import apiUrl from '../../../constants'
import axios from 'axios'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
export default {
	name: 'client',
	components: {
		Pagination,
		//  Paginate,
		Loader
	},
	data: function() {
		return {
			formattedDate: '',
			salechannelerror: false,
			considertaterror: false,
			tattimeerror: false,
			clientnameerror: false,
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: 10,
			showSelectWarehouse: false,

			//currentPage: 0,
			modalShow: false,
			editBinmodal: false,
			addChannelmodal: false,
			addmodalshow: false,
			modalShowForsyncorder: false,
			modalShowForsyncInventory: false,

			status: '',
			channelaction: '',
			listChannelData: [],
			listMaxCountdata: [],
			WarehouseErr: '',
			// pageno: 0,
			// pagecount: 0,
			showSelectClient: false,
			isLoading: false,
			is_Loading: false,
			resultCount: 0,
			editBinname: '',
			SalesChannelname: '',
			addSalesChannel: '',
			Clientsearch: '',
			clientname: '',
			listclientData: [],
			changestatus: '',
			uniorderstatus: '',
			uniInvenotrystatus: '',

			qtyerror: false,
			considertat: '',
			tattime: '',
			tattimeError: '',
			showtattime: false,
			channelid: '',
			updateChannelmodal: false,
			clientnameupdate: '',
			updateSalesChannel: '',
			considertatupdate: '',
			showtattimeupdate: false,
			tattimeupdate: '',
			tattimeErrorUpdate: '',
			modalShowForAllowCsvOrder: false,
			allowCsvOrderStatus: 0,
			getsubinventorydata: [],
			subinventory: '',
			user_type: '',
			updatesubinventory: ''
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	filters: {
		moment: function(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		}
	},
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.pageno = 0
		// this.getClientList()
		// this.getChannelData()
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		// var temp = this.useremail.split('/');

		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getClientList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.getClientList();
				this.showSelectWarehouse = false;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectWarehouse = true;
				// this.getClientList();

				this.getChannelData();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		checkinput() {
			if (this.addSalesChannel <= 0 && this.addSalesChannel != '') {
				this.qtyerror = true;
			} else {
				this.qtyerror = false;;

			}
		},
		resetTatTime() {
			if (this.considertat == '') {
				this.considertaterror = true;
			} else {
				this.considertaterror = false;
			}

			if (this.channelaction == 'add') {
				if (this.considertat == "no") {
					this.tattime = '';
					//document.getElementById('tattime').value = "";
					this.showtattime = false;
				} else {
					this.showtattime = true;
				}
			} else {
				if (this.considertatupdate == "no") {
					this.tattimeupdate = '';
					this.showtattimeupdate = false;
				} else {
					this.showtattimeupdate = true;
				}
			}

		},
		getsubinventory(clientid = null) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				'clientid': localStorage.getItem("selectedClient"),
				'inventoryname': '',
				'limit': 10,
				'offset': 0
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'GetInventoryList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					this.getsubinventorydata = result.data.data;
					this.getsubinventorydata.push({
						inventoryname: 'Normal'
					})
				}, error => {
					console.error(error)
				})
		},
		// getClientList() {
		// 	this.pageNo = this.totalPage = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listclientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': {},
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listclientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		//open new form(popup)
		addNewClient() {
			this.showtattime = false;
			this.channelaction = 'add';
			this.addChannelmodal = true;
			this.addSalesChannel = '';
			this.clientname = '';
			//to clear error messages(validation messages)
			this.$validator.reset();
			this.errors.clear();
		},
		// to open add modal
		addmodalShow() {
			this.Statusaction = 'add'
			this.modalShow = true
		},
		addOrdermodalShow() {
			this.Statusaction = 'add'
			this.modalShowForsyncorder = true
		},
		addInventorymodalShow() {
			this.Statusaction = 'add'
			this.modalShowForsyncInventory = true
		},
		//to close active/inactive modal
		closeaddmodalShow() {
			this.addmodalShow = false
		},
		closeStatusClientModal() {
			this.modalShow = false
		},
		closeSyncOrderModal() {
			this.modalShowForsyncorder = false
		},
		closeSyncInventoryModal() {
			this.modalShowForsyncInventory = false
		},
		//to close new form
		closeaddChannelmodal() {
			this.addChannelmodal = false
			this.SalesChannelname = '';
			this.clientname = '';
			this.addSalesChannel = '';
			this.tattime = '';
			this.considertat = '';
			this.addChannelmodal = false;
			this.salechannelerror = false;
			this.considertaterror = false;
			this.tattimeerror = false;
			this.clientnameerror = false;
		},
		//to close edit form
		closeeditBinModal() {
			this.addChannelmodal = false
		},
		getBinSearch() {
			this.currentPage = 1;
			this.getChannelData();
		},
		addmodalShow() {
			this.Statusaction = 'add'
			this.addmodalShow = true
		},
		//to get Channel list
		getChannelData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.WarehouseErr =  this.$t('common.clientError');
				this.pageno = this.pageCount = 0;
				this.listChannelData = [];
				return false;
			}
			if (this.showSelectWarehouse == true) {
				this.clientid = this.Clientsearch
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				saleschannel: this.SalesChannelname.trim(),
				clientid: localStorage.getItem("selectedClient"),
			})

			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getclientwisechannellist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listChannelData = result.data.data
					this.isLoading = false;

					this.totalCount = result.data.count
					this.resultCount = result.data.count;
					if (this.totalCount < 10) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalCount / 10);
					}
				}, error => {
					console.error(error)
				})
		},

		updateSalesChannelServer() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.clientname
			}
			if (this.considertatupdate == 'yes') {
				if (this.tattimeupdate > 100 || this.tattimeupdate < 0) {
					this.tattimeErrorUpdate = "Time Cannot Be Less Than 0 & Greater Than 100";
					return false;
				}
			}
			this.is_Loading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateChannelData',
					'data': {
						'clientid': localStorage.getItem("selectedClient"),
						'channelid': this.channelid,
						'saleschannel': this.updateSalesChannel,
						'createdby': this.useremail,
						'considertat': this.considertatupdate,
						'tattime': this.tattimeupdate,
						'subinventory': this.updatesubinventory
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.is_Loading = false;
						this.tattimeErrorUpdate = "";
						this.$alertify.success(response.data.msg)
						this.updateChannelmodal = false;
						this.resetaddDeatilsFormUpdate();
						this.getChannelData();

					} else if (response.data.errorCode == -1) {
						this.is_Loading = false
						this.$alertify.error(response.data.msg)
						this.updateChannelmodal = true
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})

		},
		// save form fields in mysql database
		saveSalesChannel() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.clientname
			}
			if (this.qtyerror == true) {
				return false;
			}
			if (this.considertat == 'yes') {
				if (this.tattime > 100 || this.tattime < 0) {
					this.tattimeError = "Time Cannot Be Less Than 0 & Greater Than 100";
					return false;
				}
			}


			if (this.considertat == 'no') {
				if (this.tattime == '') {
					this.tattime = 0
				}
			}


			this.is_Loading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveChannelData',
					'data': {
						'clientid': localStorage.getItem("selectedClient"),
						'saleschannel': this.addSalesChannel,
						'createdby': this.useremail,
						'considertat': this.considertat,
						'tattime': this.tattime,
						'subinventory':this.subinventory
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.is_Loading = false;
						this.tattimeError = "";
						this.$alertify.success(response.data.msg)
						this.addChannelmodal = false;
						this.resetaddDeatilsForm();
						this.getChannelData();

					} else if (response.data.errorCode == -1) {
						this.is_Loading = false
						this.$alertify.error(response.data.msg)
						this.addChannelmodal = true
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		getChannelRowData(data) {
			this.getsubinventory(localStorage.getItem("selectedClient"));
			this.channelid = data.id;
			//console.log(data);
			this.clientnameupdate = data.clientid;
			this.updateSalesChannel = data.saleschannel;
			this.considertatupdate = data.considertat;
			this.tattimeupdate = data.tattime;
			this.showtattimeupdate = data.considertat == 'yes' ? true : false;
			this.channelaction = 'update';
			this.updateChannelmodal = true;
			if (data.subinventory != '' && data.subinventory != null)
				this.updatesubinventory = data.subinventory
			else
				this.updatesubinventory = 'Normal'


		},
		closeupdateChannelmodal() {
			this.updateChannelmodal = false
		},

		getStatusRowData(data) {
			this.Statusaction = 'add'
			this.modalShow = true
			this.id = data.id
			this.clientid = localStorage.getItem("selectedClient")
			this.status = data.status
			console.log("=======data.status======",data.status);
			if (data.status.trim() == 'active') {
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
		},
		getStatusRowfororderSyncData(data) {
			this.Statusaction = 'add'
			this.modalShowForsyncorder = true
			this.id = data.id
			this.clientid = data.clientid
			this.uniordersync = data.uniordersync
			if (data.uniordersync == 1) {
				this.uniorderstatus = 'OFF'
			} else {
				this.uniorderstatus = 'ON'
			}
		},
		getStatusRowforInventorySyncData(data) {
			this.Statusaction = 'add'
			this.modalShowForsyncInventory = true
			this.id = data.id
			this.clientid = data.clientid
			this.uniinventorysync = data.uniinventorysync
			if (data.uniinventorysync == 1) {
				this.uniInvenotrystatus = 'OFF'
			} else {
				this.uniInvenotrystatus = 'ON'
			}
		},
		changeClientStatus() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateClientchannelStatus',
					'data': {
						'clientid': localStorage.getItem("selectedClient"),
						'status': this.status,
						'id': this.id
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.msg > 0) {
						this.$alertify.success("Client Sales Channel Status update Successfully")
						this.addclientmodal = false
						this.getChannelData();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		changeClientOrderSyncStatus() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateuniordersyncStatus',
					'data': {
						'clientid': localStorage.getItem("selectedClient"),
						'uniordersync': this.uniordersync,
						'id': this.id
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.msg > 0) {
						this.$alertify.success("Client Order Sync Status update Successfully")
						this.modalShowForsyncorder = false
						this.getChannelData();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		changeClientInventorySyncStatus() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateuniinventorysyncStatus',
					'data': {
						'clientid': localStorage.getItem("selectedClient"),
						'uniinventorysync': this.uniinventorysync,
						'id': this.id
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.msg > 0) {
						this.$alertify.success("Client Inventory Sync Status update Successfully")
						this.modalShowForsyncInventory = false
						this.getChannelData();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		resetForm() {
			this.SalesChannelname = '';
			this.Clientsearch = '';
			this.resultCount = 0;
			this.listChannelData = [];
		},
		resetaddDeatilsForm() {
			this.SalesChannelname = '';
			this.clientname = '';
			this.addSalesChannel = '';
			this.tattime = '';
			this.considertat = '';
			this.addChannelmodal = false;
			this.salechannelerror = false;
			this.considertaterror = false;
			this.tattimeerror = false;
			this.clientnameerror = false;

		},
		resetaddDeatilsFormUpdate() {
			this.updateSalesChannel = '';
			this.clientnameupdate = '';
			this.updatesubinventory = '';
			this.considertatupdate = '';
			this.showtattimeupdate = false;
			this.tattimeupdate = '';
			this.tattimeErrorUpdate = '';
			this.updateChannelmodal = false;
			this.channelaction = 'add';
		},

		//change status of modal
		closeStatusBinModal() {
			this.modalShow = false
			this.modalShowForsyncorder = false
		},

		onPageChange(page) {
			this.currentPage = page;
			this.getChannelData()
		},
		checkvalidinputchannel() {
			if (this.addSalesChannel == '') {
				this.salechannelerror = true;
			} else {
				this.salechannelerror = false;
			}
		},
		checkvalidconsidertat() {
			if (this.considertat == '') {
				this.considertaterror = true;
			} else {
				this.considertaterror = false;
			}
		},
		checkvalidtattime() {
			if (this.tattime == '') {
				this.tattimeerror = true;
			} else {
				this.tattimeerror = false;
			}
		},

		//validate all form fields on onsubmit()
		checkvalidInput() {
			this.getsubinventory()
			if (this.clientname == '') {
				this.clientnameerror = true;
			} else {
				this.clientnameerror = false;
			}
		},
		// clientSelected() {
		// 	//	console.log("slee")
		// 	this.getsubinventory()
		// 	if (this.clientid != this.clientname || this.clientid == this.clientname) {
		// 		this.clientid = this.clientname;
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {

		// 		}
		// 	}

		// },

		onSubmit() {
			if (this.addSalesChannel == '' || this.considertat == '' || localStorage.getItem("selectedClient") == '') {
				if (this.addSalesChannel == '') {
					this.salechannelerror = true;

				} else {
					this.salechannelerror = false;
				}
				if (this.considertat == '') {
					this.considertaterror = true;

				} else {
					this.considertaterror = false;
				}
				if (this.considertat == 'yes') {
					if (this.tattime == '') {
						this.tattimeerror = true;

					} else {
						this.tattimeerror = false;
					}
				}

				if (this.clientname == '') {
					this.clientnameerror = true;
				} else {
					this.clientnameerror = false;
				}
				return false;

			}
			if (this.addSalesChannel != '' && this.considertat != '' && localStorage.getItem("selectedClient") != '') {
				if (this.considertat == 'yes') {
					if (this.tattime == '') {
						this.tattimeerror = true;
						return false;

					} else {
						this.tattimeerror = false;
					}
				}
				this.saveSalesChannel();
			}

		},
		getStatusRowforAllowCsvOrder(data) {
			this.modalShowForAllowCsvOrder = true
			this.id = data.id
			this.clientid = data.clientid
			if (data.allowcsvorder == 0) {
				this.allowCsvOrderStatus = 1
			} else {
				this.allowCsvOrderStatus = 0
			}
		},
		changeClientAllowCsvOrderStatus() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateAllowCsvOrderStatus',
					'data': {
						'clientid': localStorage.getItem("selectedClient"),
						'allowcsvorder': this.allowCsvOrderStatus,
						'id': this.id
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					this.isLoading = false
					if (response.data.status) {
						this.$alertify.success("Allow CSV Order Status update Successfully")
						this.modalShowForAllowCsvOrder = false
						this.getChannelData();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		closeCsvOrderModal() {
			this.modalShowForAllowCsvOrder = false
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/clientchannelmaster/clientchannelmaster.component.js